module.exports = __webpack_public_path__ + "assets/7c3fc07f0191434c4f06bca457bfb12e.png";